import { render, staticRenderFns } from "./ServiceDocument.vue?vue&type=template&id=6f098be8&scoped=true"
import script from "./ServiceDocument.vue?vue&type=script&lang=js"
export * from "./ServiceDocument.vue?vue&type=script&lang=js"
import style0 from "./ServiceDocument.vue?vue&type=style&index=0&id=6f098be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f098be8",
  null
  
)

export default component.exports